import React, { useState } from 'react';
import './VehicleCard.css';

const VehicleCard = ({ vehicle, onUpdate, onDelete, userRole }) => {
  const [showActions, setShowActions] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleBoardUnboard = async (action) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/trips.php', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          vehicle_id: vehicle.id,
          action: action,
          origin: vehicle.starting_place || vehicle.starting_plant_name || 'Unknown',
          destination: action === 'UNBOARD' ? (vehicle.starting_place || vehicle.starting_plant_name || '') : '',
          notes: `${action === 'BOARD' ? 'Vehicle boarded' : 'Vehicle unboarded'} manually`
        })
      });

      const data = await response.json();
      if (data.success) {
        onUpdate();
      }
    } catch (error) {
      console.error('Error updating trip:', error);
    } finally {
      setLoading(false);
      setShowActions(false);
    }
  };

  const getStatusChip = () => {
    if (vehicle.current_status === 'boarded') {
      if (vehicle.time_info?.is_overdue) {
        return <span className="status-chip overdue">⏰ Overdue</span>;
      }
      return <span className="status-chip boarded">✅ Boarded</span>;
    }
    return <span className="status-chip unboarded">⏸️ Unboarded</span>;
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return 'Never';
    const date = new Date(timeStr);
    return date.toLocaleString();
  };

  const calculateTimeDisplay = () => {
    if (vehicle.current_status === 'boarded' && vehicle.time_info) {
      return (
        <div className={`time-display ${vehicle.time_info.is_overdue ? 'overdue' : 'remaining'}`}>
          {vehicle.time_info.display}
        </div>
      );
    }
    return null;
  };

  return (
    <div className={`vehicle-card ${vehicle.current_status || 'unboarded'}`}>
      <div className="card-header">
        <div className="vehicle-info-header">
          <div className="vehicle-number-section">
            <h3>{vehicle.vehicle_number}</h3>
            {getStatusChip()}
          </div>

          <div className="card-actions">
            <button
              className="btn-icon"
              onClick={() => setShowActions(!showActions)}
              disabled={loading}
            >
              {loading ? '⋯' : '⋮'}
            </button>

            {showActions && (
              <div className="dropdown-menu">
                {vehicle.current_status === 'unboarded' ? (
                  <button
                    onClick={() => handleBoardUnboard('BOARD')}
                    className="dropdown-item"
                  >
                    <span>✅</span> Mark as Boarded
                  </button>
                ) : (
                  <button
                    onClick={() => handleBoardUnboard('UNBOARD')}
                    className="dropdown-item"
                  >
                    <span>⏸️</span> Mark as Unboarded
                  </button>
                )}

                {userRole === 'admin' && (
                  <>
                    {/* Uncomment when you implement edit */}
                    {/* <button className="dropdown-item">
                      <span>✏️</span> Edit Vehicle
                    </button> */}

                    <button
                      className="dropdown-item delete"
                      onClick={() => onDelete(vehicle.id)}
                    >
                      <span>🗑️</span> Delete
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="card-content">
        <div className="driver-section">
          <div className="info-row">
            <span className="info-label">Driver:</span>
            <span className="info-value">{vehicle.driver_name || 'Not assigned'}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Phone:</span>
            <span className="info-value">{vehicle.driver_phone || 'N/A'}</span>
          </div>
        </div>

        <div className="vehicle-details">
          <div className="info-row">
            <span className="info-label">Type:</span>
            <span className="info-value">{vehicle.vehicle_type || 'Not specified'}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Vendor:</span>
            <span className="info-value">{vehicle.vendor || 'Not specified'}</span>
          </div>

          {/* Updated Starting Plant display */}
          <div className="info-row">
            <span className="info-label">Plant Name:</span>
            <span className="info-value">
              {vehicle.starting_plant_name || vehicle.starting_place || 'Not specified'}
            </span>
          </div>

          {/* Optional: show more plant info (uncomment if you want) */}
          {/* {vehicle.starting_plant_name && (
            <>
              <div className="info-row">
                <span className="info-label">Plant Address:</span>
                <span className="info-value">{vehicle.starting_plant_address || '—'}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Plant Contact:</span>
                <span className="info-value">
                  {vehicle.starting_plant_contact_name || '—'}
                  {vehicle.starting_plant_contact_number && ` (${vehicle.starting_plant_contact_number})`}
                </span>
              </div>
            </>
          )} */}
        </div>
      </div>

      <div className="card-footer">
        <div className="time-info-section">
          <div className="time-info">
            <span className="time-label">Last Boarded:</span>
            <span className="time-value">{formatTime(vehicle.last_boarded)}</span>
          </div>
          <div className="time-info">
            <span className="time-label">Last Unboarded:</span>
            <span className="time-value">{formatTime(vehicle.last_unboarded)}</span>
          </div>
        </div>

        {calculateTimeDisplay()}
      </div>

      <div className="card-created">
        <span className="created-by">
          Added by: {vehicle.created_by_name || 'System'}
        </span>
      </div>
    </div>
  );
};

export default VehicleCard;